import React from 'react'
import { Drawer, makeStyles } from '@material-ui/core'

export const ANCHOR_OPTIONS = {
    right: 'right',
    left: 'left',
    top: 'top',
    bottom: 'bottom'
}

const useStyles = makeStyles(theme => ({
    drawerWrapper: {
        display: 'flex',
        flexDirection: 'column',
        padding: 20,
        minWidth: 300
    }
}))

export function CustomDrawer({
    children,
    anchor = ANCHOR_OPTIONS.right,
    open,
    handleClose
}) {
    const classes = useStyles()
    return (
        <Drawer anchor={anchor} open={open} onClose={() => handleClose(false)}>
            <div className={classes.drawerWrapper}>{children}</div>
        </Drawer>
    )
}
